function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#348C30;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M277.4,330.9c-10.6,0-19.2-8.9-18.6-19.6c0.5-10.1,9.6-17.6,19.7-17.6h58.7c18.3-16.5,29-41.2,26.1-68.3 c-3.9-37-33.8-67-70.8-71c-48.4-5.3-89.4,32.5-89.4,79.8c0,23.7,10.4,45,26.7,59.7c-45.3,20.5-76.6,66.3-76.1,119.4h259.4 c0.3-31.1-10.4-59.7-28.4-82.2H277.4z"
});

var SvgOxyRh = function SvgOxyRh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOxyRh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oxy-rh.1cd13282.svg";
export { ForwardRef as ReactComponent };